module.exports = __webpack_public_path__ + "static/media/eva_message-circle-outline.ca4f449c.svg";